import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.png')}
					title={"How (And Why!) To Avoid Spam Posts in Facebook Groups"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 28 May 2020  //  Posted in <strong>Marketing</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									How (And Why!) To Avoid Spam Posts in Facebook Groups
								</div>
								<h2>A lot of Facebook group Admins ask us about ‘spammy’ posts in their group.</h2>
								<p>This blog will be covering the damage that these posts can create for your brand and for your group community, and how to best avoid them in your group completely. And no, we’re not referring to ‘spiced ham in a can’ spam.</p> 

<p>If Facebook is something you struggle with, or it’s not giving you the results you are wanting, we are always <a href="https://www.moshi.com.au/contact-us">here to help</a>.</p>
<br></br>
<hr></hr>
<h2>Why start a Facebook group?</h2>
<p>The first question you may have is ‘what’s the point of starting a group in the first place?’ A Facebook group is a great way to cultivate and educate a community of like minded people and draw in businesses of a similar field. Groups create conversation by sharing advancements in technology, sharing new pieces of work, introducing themselves to others, asking advice on common situations, and spreading rich content.</p>

<p>There is another large benefit to creating a Facebook group - it shows you as being a leader in your industry. You have knowledge to share, and you have a group of people hanging onto your every article share or opinion piece.</p>
<br></br>
<hr></hr>
<h2>So, what is a ‘spam’ post? And why are they bad?</h2> 
<p>A post is considered spam if it’s is irrelevant to the group and conversation, or contains unsolicited business promotions.</p>
<p>The purpose of a Facebook group is to create a safe space for a community of people to share information and discuss ideas and/or projects. The purpose of the group becomes unclear however, when group members begin being bombarded with personal promotions or promotions of the business they work for.</p>
<p> Think about how you feel with pushy salespeople in real life situations. Do you want to continue shopping or browsing when you’re being harassed to purchase? Probably not. </p> 
<p>Given that you are literally on a social site, chances are the uncomfortable users will leave your group, and convince their friends to leave as well.</p> 

<br></br>
<hr></hr>
<h2> Why Your Should Remove Spam Generating Users:</h2>
<ul>
<li>They make people uncomfortable. <p>Uncomfortable people are less likely to bring valuable content to the conversation, or get involved in group discussions.</p></li>
<li>They lower the credibility of your brand - personal or business. <p>Your name is attached to this group. You don't want spam posts reflecting negatively on your brand.</p></li>
<li>It takes time to manually remove spam posts from your group. <p>Eliminate that time completely by creating filters to easily decline fake accounts.</p></li>
</ul>
<br></br>
<hr></hr>
<h2>How To Avoid Spammers in the First Place:</h2>

<h3>1. Make Your Group Closed, or Invite Only.</h3>

<img src={require('./image-5.png')} alt="facebook Group Settings" height="250" class="align-left" align="left"/>
<p> Once you have created a Facebook group, you have access to a whole range of Security and Privacy options to filter who can and who can’t join. These are all found to the left of your screen on a desktop, or under the ‘shield’ menu in the top right on mobile. The best way to avoid spam accounts is to know how to recognise them before they join.</p>
<br></br>

<img src={require('./image-2.png')} alt="Facebook Group Settings"/>

<p>Start by clicking on your Settings tab, and go through the Set Up, Manage Membership and Manage Discussion tabs one by one to make sure your group is exclusively invitation only or closed to members.</p>
<br></br>
<br></br>
<h3>2. Filter Through Member Requests</h3>
<p>The use of the Member Requests filter features will slash your approval time in half. There are ways to identify spam accounts straight away:</p>

<img src={require('./image-4.png')} alt="Facebook Group Settings" height="400"class="align-left" align="left"/>
<br></br>
<ul>
<li><b>Joined Facebook Date:</b> Spammers and bots create accounts and then disappear once their job is done. With that in mind, treat any accounts younger than three months with caution.</li>

<li><b>Profile Picture:</b>If an account hasn’t taken the time to add a profile picture, they’re probably not going to bother adding rich content to your group. DECLINE. 
Alternatively, be wary of stock photo profile pictures. If you are suspicious that an account is fake, try saving the user’s photo and upload to <a href="https://www.google.com/imghp?hl=en"> Google Images</a> to find photos of a similar stock model.</li>

<li><b>Invited:</b>If a group member invited them to join, there’s much less of a chance that the member in question is a fake account. If they have requested to join, make sure you check through the other filters to ensure they are legitimate.</li>
</ul>
<br></br>
<h3>3. Add Questions to Membership Requests</h3>
<p>Adding questions is a simple way to filter out bots or people who aren’t going to be valuable to your group (harsh, but true). To add a question to your membership request, head to ‘Membership Questions’ on the left of your page. From there it’s easy to add your own questions. The harder the question, the easier to filter out bot accounts.</p>

<img src={require('./image-3.png')} alt="facebook Group Settings" height="500"/>

<br></br><br></br>
<h3>4. Make Your Group Rules Clear, and Pinned to the Top of Your Page</h3>
<p>Not all spammers are fake accounts or bots. Some are merely people who have not read the rules or simply don’t understand them. Your rules should be concise, clear, and if possible, turned into a graphic that grabs people’s attention.</p>
<br></br>
<h3>5. Make Your Best Users Moderators</h3>
<p>If you are experiencing high levels of spam, it can be very time consuming to manually delete every post that gets shared. If you have identified users in your group that are constantly creating conversation, sharing new ideas or content, it may be time to promote them to Admin status. Not only are they pretty chuffed to be a part of the crew running the page (woohoo!), but it also means less of your time spent removing spam.</p> 
<br></br>
<p>By filtering your admission requests, running through your page settings, manually reviewing posts and creating questions to be answered, you should be pretty clear of spammy posts in your group. It’s definitely worth checking your ‘Group Quality’ tab often as well, to make sure you’re not in breach of any community standards.</p>  

<h3>Again, if you are looking for ways to improve your digital presence on <a href="https://www.moshi.com.au/whatwedo/social-media-management"> Facebook, Instagram or LinkedIn</a>, Moshi Moshi are here to help.</h3> 



							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/FBGroup/index.js